var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgNotificationBein = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40Z",
    fill: "#87B0B4"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.85
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.0001 19V24L27.2901 25.29C27.9201 25.92 27.4701 27 26.5801 27H13.4101C12.5201 27 12.0801 25.92 12.7101 25.29L14.0001 24V19C14.0001 15.92 15.6301 13.36 18.5001 12.68V12C18.5001 11.17 19.1701 10.5 20.0001 10.5C20.8301 10.5 21.5001 11.17 21.5001 12V12.68C24.3601 13.36 26.0001 15.93 26.0001 19ZM22.0001 28C22.0001 29.1 21.1001 30 20.0001 30C18.8901 30 18.0001 29.1 18.0001 28H22.0001Z",
    fill: "white"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgNotificationBein, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/notification-bein.4d818043.svg";
export { ForwardRef as ReactComponent };